import React, { FC, useContext, useEffect, useMemo, useState } from 'react';
import utils, { getResolveUrl } from 'utils';
import { useNavigate, useParams } from 'react-router-dom';
import api from 'api';
import useSiteInitializedState from 'hooks/useSiteInitializedState';
import { Listing } from 'models/Listing';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import HelmetWrapper from 'components/HelmetWrapper';
import { BusinessTeaser } from 'components/BusinessTeaser';
import { BUSINESS_ROUTE } from 'data/global';

const BusinessEnquire: FC = () => {
  const { listingSlug } =
    useParams<{ listingSlug: string; listingCategory: string }>();

  const navigate = useNavigate();
  const { popServerError } = useContext(PopNotificationsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [listing, setListing] = useSiteInitializedState<Listing>(
    `listing-${listingSlug}`,
  );

  useEffect(() => {
    !utils.isSSGHuman() &&
      listingSlug &&
      (async () => {
        setListing((old) => {
          if (!old) setIsLoading(true);
          return old;
        });

        try {
          const {
            data: { listing },
          } = await api.listings.getListingWithSlug(listingSlug);

          setListing(listing);
        } catch (e) {
          navigate(BUSINESS_ROUTE);
        } finally {
          setIsLoading(false);
        }
      })();
  }, [listingSlug, navigate, popServerError, setListing]);

  const HelmetContent = useMemo(() => {
    if (!listing) return <></>;

    const helmetUrl = getResolveUrl(
      `${utils.composeBusinessUrl(
        listing.industry,
        listing.slugName,
        listing.type,
      )}/teaser`,
    );
    const title = `${listing.listingTitle} | Resolve`;
    const description = listing.businessDescription.slice(0, 150);
    const image = listing.gallery?.[0]?.url;

    return (
      <HelmetWrapper
        title={title}
        description={description}
        url={helmetUrl}
        facebookImg={image}
        twitterImg={image}
      />
    );
  }, [listing]);

  return (
    <>
      {HelmetContent}
      <BusinessTeaser isLoading={isLoading} listing={listing} />
    </>
  );
};

export default BusinessEnquire;
